$('.event__attend').on('click', (e) => {
	e.preventDefault();

	$('.popup').show();
	$('body').addClass('is-popup-open');
});

$('.popup__close').on('click', (e) => {
	e.preventDefault();

	$('.popup').hide();
	$('body').removeClass('is-popup-open');
});
